import React from 'react'
import { useLocation, Link } from 'react-router-dom';

const LinkContainer = ({Icon, title, to}) => {
  const { pathname } = useLocation();

  return (
    <>
        <Link to={to} className="flex group  items-center space-x-2">
        <div className={`w-[35%] transition-all text-white group-hover:bg-secondary/20 py-4 rounded-tr-full rounded-br-full flex justify-end pr-4 ${pathname.startsWith(`${to}`)  ? "bg-secondary" : ""}`}>
          <Icon className={`text-2xl !text-white group-hover:text-white ${pathname.startsWith(`${to}`) ? "!text-white" : ""}`}/>
        </div>
        <span className={`font-medium text-white  text-xs ${pathname.startsWith(`${to}`) ? "text-white" : ""}`}>
          {title}
        </span>
      </Link>
    </>
  )
}

export default LinkContainer